import { useHttpClient } from '@wix/fe-essentials/react';
import { useQuery } from '@wix/fe-essentials/react-query/react';
import { fetchRulesData } from '../api/fetch-rules-data';
import { QueryId } from './types';
export const useFetchRulesData = () => {
  const httpClient = useHttpClient();
  return useQuery([QueryId.RulesData], () => fetchRulesData(httpClient), {
    refetchOnWindowFocus: false,
    retry: false
  });
};
//# sourceMappingURL=use-fetch-rules-data-query.js.map